module.exports = __webpack_public_path__ + "static/media/plus-square.aec856b5.svg";